export default __webpack_public_path__ + "static/057-796830eacda14451bc254c8cc61a6d50.jpg";